module.exports = __webpack_public_path__ + "static/media/layer7-box.48c2be0e.png";